module.exports = __webpack_public_path__ + "static/media/YT.84a542c2.svg";